module.exports = {
      id: "icons:home-usage",
      viewBox: "0 0 20 22",
      url: "/static/" + "sprites.1e5806fb7235408b9281f0924c9110c8.svg#icons:home-usage",
      toString: function () {
        return this.url;
      }
    }